import styled from 'styled-components'

const StLink = styled.a`
  color: ${({ theme }) => theme.Colors.Theme.Primary};
  display: flex;
  gap: ${({ theme }) => theme.UI.SpacingPx.Space2};
`

export { StLink }
